import { useMemo } from "react";

import FlexWrapper, { FlexDirection } from "@gx/dls/containers/FlexWrapper";
import GridWrapper, { GridAlignContent, GridAlignItems } from "@gx/dls/containers/GridWrapper";
import { SourceSyncOperationMetadataWikipedia } from "@gx/ts-contracts/services/source/resources/source_sync_operation_metadata/source_sync_operation_metadata_pb";

import EmptyLayout from "@/layouts/EmptyLayout";

import EditSourceContentToolbar from "@/pages/sources/components/edit/tabs/content/EditSourceContentToolbar";
import SourceContentFileBadge from "@/pages/sources/components/SourceContentFileBadge";

interface EditSourceContentWikipediaProps {
  items: SourceSyncOperationMetadataWikipedia[];
  search: string;
  onSearchChange: (value: string) => void;
}

const EditSourceContentWikipedia = ({
  items,
  search,
  onSearchChange,
}: EditSourceContentWikipediaProps) => {
  const filtered = useMemo(() => {
    const query = search.trim().toLowerCase();
    if (!query) return items;
    return items.filter(
      (item) =>
        item.pageTitle?.toLowerCase().includes(query) ||
        item.pageUrl?.toLowerCase().includes(query),
    );
  }, [items, search]);

  return (
    <FlexWrapper direction={FlexDirection.COLUMN} fillWidth fillHeight minHeight={0}>
      <EditSourceContentToolbar
        search={search}
        count={items.length}
        onSearchChange={onSearchChange}
      />
      <FlexWrapper padding="12px" fillWidth fillHeight minHeight={0} overflow="auto">
        {filtered.length > 0 ? (
          <GridWrapper
            columns="repeat(auto-fill, minmax(280px, 1fr))"
            gap={8}
            alignItems={GridAlignItems.START}
            alignContent={GridAlignContent.START}
            fillWidth
          >
            {filtered.map((item) => (
              <SourceContentFileBadge
                key={item.pageUrl}
                header={item.pageTitle ?? "Untitled"}
                subHeader={item.pageUrl}
              />
            ))}
          </GridWrapper>
        ) : (
          <EmptyLayout title="No content" description="No content matches your search" />
        )}
      </FlexWrapper>
    </FlexWrapper>
  );
};

export default EditSourceContentWikipedia;
